<template lang="pug">
  .columns
    .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2
      box(title="Produtos" :value="resume.products.total" icon="fas fa-box" box-style="warning")
        .divider
        box-more(label="Revistas" :value="resume.products.magazines")
        box-more(label="Livros" :value="resume.products.books")
        box-more(label="Playlists de vídeos" :value="resume.products.videos")
    .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2
      box(
        title="Assinaturas"
        :value="resume.subscriptions.total"
        icon="fas fa-dollar-sign"
        box-style="success"
        @click="$router.push({ name: 'subscriptions.list' })"
      )
        .divider
        box-more(label="Ativas" :value="resume.subscriptions.active")
        box-more(label="Canceladas" :value="resume.subscriptions.canceled")
        box-more(label="Expiradas" :value="resume.subscriptions.expired")
    .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2
      box(
        title="Contas criadas"
        :value="resume.people.total"
        icon="fas fa-users"
        @click="$router.push({ name: 'users.commons.list' })"
      )
        .divider
        box-more(label="Usuários" :value="resume.people.users")
        box-more(label="Administradores" :value="resume.people.admin")
    .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2
      box(
        title="Planos"
        :value="resume.plans.total"
        icon="fas fa-shapes"
        box-style="danger"
        @click="$router.push({ name: 'plans.list' })"
      )
        .divider
        box-more(label="Ativos" :value="resume.plans.active")
        box-more(label="Inativos" :value="resume.plans.inactive")
</template>

<script>
export default {
  props: { resume: { type: Object, required: true } },
}
</script>
